module.exports = __webpack_public_path__ + "img/data.ce9f0c99.svg";